import { useMutation } from '@tanstack/react-query';
import { fetchQuickPeekHistoricalSouvenirs } from '@/services/travelAssistantService';
import type { QuickPeekRequest } from '@/services/api/interfaces/ITravelAssistantRepository';

/**
 * Custom hook for fetching historical significance and handicrafts/souvenirs information
 * Single Responsibility: Handles only historical/souvenirs data fetching
 * Dependency Inversion: Depends on service abstraction (fetchQuickPeekHistoricalSouvenirs)
 *
 * @param accessToken - Optional access token for authentication
 * @param refreshToken - Optional refresh token for authentication
 * @returns Mutation object with mutate function and state
 */
export function useHistoricalSouvenirs(
  accessToken?: string,
  refreshToken?: string
) {
  return useMutation({
    mutationFn: async ({
      request,
      signal,
    }: {
      request: QuickPeekRequest;
      signal?: AbortSignal;
    }) => {
      return fetchQuickPeekHistoricalSouvenirs(
        request,
        accessToken,
        refreshToken,
        signal
      );
    },
    onError: error => {
      console.error(
        '[useHistoricalSouvenirs] Error fetching historical souvenirs data:',
        error
      );
    },
  });
}
